const refs = {
  //seraching-input-dropdown.js
  countriesDropdownRef: document.querySelector('.countries-dropdown__wrapper'),
  dropdownRef: document.querySelector('.dropdown'),
  dropdownTitleRef: document.querySelector('.dropdown__title'),
  dropdownIconRef: document.querySelector('.dropdown__svg'),
  countryListRef: document.querySelector('.dropdown__list'),
  searchInputRef: document.querySelector('.form-field'),
  searchIconRef: document.querySelector('.search__icon'),
  clearSearchIconRef: document.querySelector('.clear-search__icon'),
  eventCardsRef: document.querySelector('.cards__list'),

  //modal.js
  eventCardsRef: document.querySelector('.cards__list'),
  lightBox: document.querySelector('.lightbox'),
  jsLightbox: document.querySelector('.js-lightbox'),
  modalCloseBtn: document.querySelector('.lightbox__button'),
  lighBoxOverlay: document.querySelector('.lightbox__overlay'),

  //preloader.js
  preloader: document.querySelector('#preloader'),

  //theme-mode.js
  themeSwitchRef: document.querySelector('#theme-switch-toggle'),

  //pagination.js
  pagination: document.querySelector('.tui-pagination'),
};

export default refs;
